 
export enum BillingType {
   'CLOSED' = 'closed',
   'OPEN' = 'open'
}
